import ActionResultType from '../../../interfaces/pieces/ActionResultType';
import BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type { BaseLiquidationOptions } from '../../../interfaces/pieces/mouvements/liquidation/BaseLiquidationOptions';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import type TreeviewActionResult from '../../../interfaces/pieces/TreeviewActionResult';
import { updateBordereau } from '../../../services/piecesComptables/bordereaux/bordereaux';
import getMessageErreur from '../../../utils/getMessageErreur';
import BaseLiquidationAction from '../../pieces/BaseLiquidationAction';

class BordereauForceEtatAcquittementAction extends BaseLiquidationAction<
	BordereauWithState,
	BordereauActionType
> {
	isAcquittement: boolean;

	constructor(
		options: BaseLiquidationOptions & { isAcquittement: boolean } = null,
	) {
		super(options);
		this.label = options?.isAcquittement
			? 'Considérer le bordereau comme acquitté'
			: 'Considérer le bordereau comme non-acquitté';
		this.isAcquittement = options?.isAcquittement;
		this.type = options?.isAcquittement
			? BordereauActionType.FORCE_ACK
			: BordereauActionType.FORCE_NACK;
	}

	execute = (
		bordereau: BordereauWithState,
	): TreeviewActionResult<BordereauWithState> => ({
		result: Promise.resolve(bordereau),
		type: ActionResultType.MODAL,
		extraProps: {
			isSuperUser: this.isSuperUser,
			bordereauForceEtatAcquittement: {
				visible: true,
				isAcquittement: this.isAcquittement,
			},
		},
	});

	executeAction = (
		bordereau: BordereauWithState,
	): TreeviewActionResult<BordereauWithState> => ({
		type: ActionResultType.UPDATE,
		result: new Promise((resolve, reject) => {
			updateBordereau(bordereau, new URLSearchParams({ withJournaux: 'true' }))
				.then((updatedBordereau) => {
					resolve(updatedBordereau);
				})
				.catch((e) => {
					reject(
						Error(
							getMessageErreur(
								e,
								'Erreur lors de la modification du bordereau',
							),
						),
					);
				});
		}),
	});
}

export default BordereauForceEtatAcquittementAction;
